import { render, staticRenderFns } from "./AboutPage6.vue?vue&type=template&id=928b4e64&scoped=true"
import script from "./AboutPage6.vue?vue&type=script&lang=js"
export * from "./AboutPage6.vue?vue&type=script&lang=js"
import style0 from "./AboutPage6.vue?vue&type=style&index=0&id=928b4e64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928b4e64",
  null
  
)

export default component.exports